import { FC } from "react";
import { Divider, Stack } from "@mui/material";
import { ResourceDetailsCoverageTabDateRange } from "@/components/pages/common/resource-details/components/content/coverage-content/components/ResourceDetailsCoverageTabDateRange";
import { ResourceDetailsCoverageTabDataPointSelector } from "@/components/pages/common/resource-details/components/content/coverage-content/components/ResourceDetailsCoverageTabDataPointSelector";
import { ResourceDetailsCoverageTabMetadataCards } from "@/components/pages/common/resource-details/components/content/coverage-content/components/metadata/ResourceDetailsCoverageTabMetadataCards";
import { ResourceDetailsCoverageTabChartType } from "@/components/pages/common/resource-details/components/content/coverage-content/components/chart/ResourceDetailsCoverageTabChartType";
import { ResourceDetailsCoverageTabChart } from "@/components/pages/common/resource-details/components/content/coverage-content/components/chart/ResourceDetailsCoverageTabChart";
import { ResourceDetailsCoverageTabDataGrid } from "@/components/pages/common/resource-details/components/content/coverage-content/components/data-grid/ResourceDetailsCoverageTabDataGrid";

export const ResourceDetailsCoverageTabContent: FC = () => {
  return (
    <Stack height="100%">
      <Stack
        p={1.5}
        direction="row"
        alignItems="center"
        justifyContent="space-between"
      >
        <Stack direction="row" spacing={1} alignItems="center">
          <ResourceDetailsCoverageTabDateRange />

          <ResourceDetailsCoverageTabDataPointSelector />
        </Stack>

        <ResourceDetailsCoverageTabChartType />
      </Stack>

      <Divider />

      <ResourceDetailsCoverageTabMetadataCards />

      <Stack spacing={1} p={1.5} height="100%">
        <ResourceDetailsCoverageTabChart />

        <ResourceDetailsCoverageTabDataGrid />
      </Stack>
    </Stack>
  );
};
